import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavLink } from 'react-router-dom';
import Header from 'Components/HeaderPlain';

const FloraQRBasedevents = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch event counts
                const eventRes = await fetch('https://ecoclubs.education.gov.in/api/get-FloraQR-events-stateWise', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({}),
                });
                const eventData = await eventRes.json();
                const eventList = eventData?.data?.getFloraQrBasedEventCounts?.events || [];
                const totalEvents = eventData?.data?.getFloraQrBasedEventCounts?.totalCount || 0;

                // Fetch school counts
                const schoolRes = await fetch('https://ecoclubs.education.gov.in/api/get-FloraQR-schools', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({}),
                });
                const schoolData = await schoolRes.json();
                const schoolList = schoolData?.data?.getFloraQrBasedEventCounts || [];

                // Merge both datasets by state and sort alphabetically
                const mergedData = eventList.map(eventItem => {
                    const matchingSchool = schoolList.find(school => school.state === eventItem.state);
                    return {
                        state: eventItem.state,
                        count: eventItem.count,
                        participants: eventItem.total_participants,
                        schoolCount: matchingSchool?.school_count || 0,
                        treesCount: eventItem.total_trees_labelled_qr || 0,
                    };
                }).sort((a, b) => a.state.localeCompare(b.state));

                setReportData(mergedData);
                setTotalCount(totalEvents);
            } catch (err) {
                console.error('Failed to fetch report data', err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    return (
        <>
            <Header />
            <div className="container mt-5" style={{ paddingBottom: '110px' }}>
                <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>
                    Total Events Created: <strong>{totalCount}</strong>
                </h4>
                <h4 className="text-center text-primary" style={{ color: 'black', WebkitTextFillColor: 'black' }}>
                    Total Events Created For Sub Theme Flora QR codes: <strong>{reportData.reduce((total, item) => total + item.count, 0)}</strong>
                </h4>

                <div className="mt-5">
                    <h4><strong>Events Created Under Flora QR codes Subtheme</strong></h4>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>States/UTs/ABs</th>
                                <th className="text-center">Events Created</th>
                                <th className="text-center">Total Participants</th>
                                <th className="text-center">School Count</th>
                                <th className="text-center">QR labeled trees</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="6" className="text-center">Loading...</td>
                                </tr>
                            ) : reportData.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="text-center">No Data Available</td>
                                </tr>
                            ) : (
                                reportData.map((item, index) => (
                                    <tr key={item.state}>
                                        <td>{index + 1}</td>
                                        <td>{item.state}</td>
                                        <td className="text-center">{item.count}</td>
                                        <td className="text-center">{item.participants}</td>
                                        <td className="text-center">{item.schoolCount}</td>
                                        <td className="text-center">{item.treesCount}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                        <tfoot>
                            {reportData.length > 0 && (
                                <tr>
                                    <td colSpan="2" className="text-center"><strong>Total</strong></td>
                                    <td className="text-center">
                                        <strong>{reportData.reduce((total, item) => total + item.count, 0)}</strong>
                                    </td>
                                    <td className="text-center">
                                        <strong>{reportData.reduce((total, item) => total + item.participants, 0)}</strong>
                                    </td>
                                    <td className="text-center">
                                        <strong>{reportData.reduce((total, item) => total + item.schoolCount, 0)}</strong>
                                    </td>
                                    <td className="text-center">
                                        <strong>{reportData.reduce((total, item) => total + item.treesCount, 0)}</strong>
                                    </td>
                                </tr>
                            )}
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    );
};

export default FloraQRBasedevents;
